<form
  #newDeviceGroupForm="ngForm"
  (ngSubmit)="newDeviceGroupForm.valid ? saveNewDeviceGroup() : setFormDirty(newDeviceGroupForm.control)"
>
  <div class="input__container">
    <label for="name">Namn&nbsp;*</label>
    <input id="name" name="name" [(ngModel)]="deviceGroup.name" required />
  </div>

  <div class="input__container">
    <label for="description">Beskrivning&nbsp;*</label>
    <input
      id="description"
      name="description"
      [(ngModel)]="deviceGroup.description"
      required
    />
  </div>

  <dot-loader [visibility]="loading" [large]="true"></dot-loader>

  @if (!loading) {
    <h3>Instream estimat</h3>

    <table
      class="table table-woo table--info table--hover width--100"
      aria-label="Instream-estimat"
    >
      <thead>
        <tr>
          <th [colSpan]="staticFields"></th>
          <th class="capitalize--first-letter centered" colspan="3">
            Estimatfördelning
          </th>
          <th class="capitalize--first-letter centered" colspan="3">
            Maxuttag
          </th>
        </tr>
        <tr>
          @for (header of tableHeaders; track $index ) {
            <th class="text--thin text--small capitalize--first-letter">
              {{ header }}
            </th>
          }
        </tr>
      </thead>

      <tbody>
        @for (row of inputRows; track $index; let rIdx = $index) {
          @if (rowVisible(row)) {
            <tr>
              <td class="text--thin vertical-align--middle table-header-padding">
                {{ translateProductFormat(row.productFormat) }}
              </td>
              <td class="text--thin vertical-align--middle table-header-padding">
                {{ row.publisher }}
              </td>

              @for (
                slot of ['preroll', 'midroll', 'postroll'];
                track $index
              ) {
                <td class="vertical-align--middle">
                  <div class="input__container">
                    <input
                      name="row-{{ rIdx }}-shares-{{ slot }}"
                      [(ngModel)]="
                        deviceGroup.shares[row.publisherId][row.productFormatId][
                          slot
                        ]
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="includedProductFormatSlotTypes[row.productFormatId][slot]"
                      [disabled]="
                        !includedProductFormatSlotTypes[row.productFormatId][slot]
                      "
                    />
                  </div>
                </td>
              }

              @for (
                slot of ['preroll', 'midroll', 'postroll'];
                track slot
              ) {
                <td class="vertical-align--middle">
                  <div class="input__container">
                    <input
                      name="row-{{ rIdx }}-limits-{{ slot }}"
                      [(ngModel)]="
                        deviceGroup.withdrawal_limits[row.publisherId][
                          row.productFormatId
                        ][slot]
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="includedProductFormatSlotTypes[row.productFormatId][slot]"
                      [disabled]="
                        !includedProductFormatSlotTypes[row.productFormatId][slot]
                      "
                    />
                  </div>
                </td>
              }
            </tr>
          }
        }
      </tbody>
    </table>

    <h3>Outstream estimat</h3>
    <outstream-estimates-input
      [sites]="sites"
      [(shares)]="deviceGroup.outstream_shares"
      [(withdrawalLimits)]="deviceGroup.outstream_withdrawal_limits"
    ></outstream-estimates-input>
  }

  <div class="margin-top--3x">
    <button
      type="submit"
      class="button"
      [disabled]="newDeviceGroupForm.invalid"
    >
      Spara
    </button>
    <button type="button" class="link" (click)="onAbort.emit()">Avbryt</button>
  </div>
</form>
